import React from "react";
import { LuLoaderCircle, LuSearch } from "react-icons/lu";

import SearchResultItem from "./SearchResultItem";

const MIN_QUERY_LENGTH = 3;

export default function SearchResultsPanel({
  loading,
  error,
  results,
  query,
  selectedResult,
  onSelect,
}) {
  const trimmedQuery = query.trim();

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
      {/* Header */}
      <div className="flex shrink-0 items-center justify-between border-b border-slate-100 bg-slate-50 px-4 py-3">
        <span className="text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-400">
          Search Results
        </span>

        {!loading && results.length > 0 && (
          <span className="rounded-full bg-slate-200 px-2 py-0.5 text-[10px] font-semibold text-slate-500">
            {results.length} results
          </span>
        )}
      </div>

      {/* Loading */}
      {loading && (
        <div className="flex flex-1 items-center justify-center p-8">
          <div className="text-center">
            <LuLoaderCircle
              size={22}
              className="mx-auto animate-spin text-blue-600"
            />

            <p className="mt-3 text-[13px] font-medium text-slate-500">
              Searching...
            </p>
          </div>
        </div>
      )}

      {/* Error */}
      {!loading && error && (
        <div className="flex flex-1 items-center justify-center p-8">
          <div className="max-w-sm text-center">
            <p className="text-[13px] font-semibold text-red-500">
              Search failed
            </p>

            <p className="mt-1 text-[12px] text-slate-400">{error}</p>
          </div>
        </div>
      )}

      {/* No Results */}
      {!loading &&
        !error &&
        results.length === 0 &&
        trimmedQuery.length >= MIN_QUERY_LENGTH && (
          <div className="flex flex-1 items-center justify-center p-8">
            <div className="text-center">
              <LuSearch size={28} className="mx-auto text-slate-300" />

              <p className="mt-3 text-[13px] font-semibold text-slate-600">
                No results found
              </p>

              <p className="mt-1 text-[12px] text-slate-400">
                No results found for "{trimmedQuery}"
              </p>
            </div>
          </div>
        )}

      {/* Results */}
      {!loading && !error && results.length > 0 && (
        <div className="min-h-0 flex-1 overflow-y-auto">
          {results.map((result, index) => (
            <SearchResultItem
              key={result.id || result.url || `${index}-${result.title}`}
              result={result}
              selected={selectedResult?.url === result.url}
              onSelect={onSelect}
            />
          ))}
        </div>
      )}
    </div>
  );
}
